import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-100 border-t border-background-200/60">
      <div className="max-w-7xl mx-auto px-6 md:px-8 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 md:gap-8">
          <div>
            <Link to="/" className="inline-block">
              <span className="font-heading text-xl font-semibold text-foreground-900">
                Sugargoo<span className="text-primary-500">Spreadsheet</span>
              </span>
            </Link>
            <p className="mt-3 text-sm text-foreground-600 leading-relaxed max-w-xs">
              The ultimate Sugargoo Spreadsheet resource center. Helping shoppers discover products, compare options, and make smarter purchasing decisions since 2026.
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              <a href="#quick-links" className="hover:text-primary-500 transition-colors">Quick Links</a>
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Home
                </Link>
              </li>
              <li>
                <Link to="/sugargoo-spreadsheet-ultimate-guide" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Ultimate Sugargoo Spreadsheet Guide
                </Link>
              </li>
              <li>
                <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-sm text-foreground-600 hover:text-primary-500 transition-colors">
                  Visit Main Platform
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-foreground-900 mb-4">
              <a href="#disclaimer" className="hover:text-primary-500 transition-colors">Disclaimer</a>
            </h4>
            <p className="text-sm text-foreground-600 leading-relaxed">
              This website provides independent educational information about Sugargoo products, shopping processes, and resources. We do not process payments or guarantee third-party products. Always research sellers and products before purchasing.
            </p>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-200/60 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} Sugargoo Spreadsheet Hub. All rights reserved. This is an independent information platform.
          </p>
          <div className="flex items-center gap-5">
            <a href="https://kaspreadsheet.com" target="_blank" rel="noopener nofollow" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
              Main Platform
            </a>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
              Privacy
            </Link>
            <Link to="/" className="text-xs text-foreground-500 hover:text-primary-500 transition-colors whitespace-nowrap">
              Terms
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}